// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { InitDataRequest } from '../Messages/InitDataRequest';
export class InputInitDataRequstMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        return [new InitDataRequest(fieldSet)];
    }
}
